import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { TypedBulletList } from '../interactions/TypedBulletList.jsx'

const TYPE_OPTIONS = [
  { id: 'tech',     label: 'tech',     tone: 'moss' },
  { id: 'people',   label: 'people',   tone: 'clay' },
  { id: 'career',   label: 'career',   tone: 'berry' },
  { id: 'process',  label: 'process',  tone: 'mustard' },
  { id: 'product',  label: 'product',  tone: 'olive' },
]

const SOFT_CAP = 3

/**
 * FocusCard — typed bullet list (tech/people/career/process/product), soft cap 3.
 * catalog #8, prep-focus. Shape-shift from chip-multi-context + adds 'product'.
 */
export function FocusCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []
  const hasBullets = items.some((i) => i.text)
  const isOver = items.filter((i) => i.text).length > SOFT_CAP

  return (
    <CardFrame
      kind="prep"
      icon="⊙"
      iconClass="olive"
      title="Focus areas"
      prompt="Where is your attention this week?"
      state={disabled ? 'locked' : isOver ? 'error' : hasBullets ? 'filled' : 'empty'}
      data-testid="prep-card-prep-focus"
      className="prepcard"
    >
      <TypedBulletList
        items={items}
        onChange={onChange}
        typeOptions={TYPE_OPTIONS}
        maxItems={8}
        maxChars={140}
        placeholder="An area of focus…"
        disabled={disabled}
        required
      />
      {isOver && !disabled && (
        <p style={{ fontSize: 11, color: 'var(--color-danger-text)', padding: '0 14px 8px', fontStyle: 'italic' }}>
          Aim for 3 or fewer focus areas.
        </p>
      )}
    </CardFrame>
  )
}
